import React, { memo } from 'react';
export function BonusSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-69" data-mp="1cc89w9fyb9dd">
      <div className="max-w-5xl mx-auto" data-id="element-70" data-mp="1ogn8frff7v70">
        <div className="text-center mb-6" data-id="element-71" data-mp="1ofly5p68bcqc">
          <h2 className="text-[20px] font-black mb-2 text-[#5A3FA0]" data-id="element-72" data-mp="22g52ombhk0nr">
            ADEMÁS RECIBÍS ESTOS BONUS
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-600 mb-4" data-id="element-73" data-mp="1yf3324dnpml9"></h3>
          <div className="inline-block bg-red-600 text-white text-xl md:text-2xl font-black px-8 py-3 rounded-full shadow-lg animate-bounce" data-id="element-74" data-mp="1anxmfmzw6q9w">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="space-y-6" data-id="element-75" data-mp="1jhsscx8u8kql">
          {/* Bonus 1 */}
          <div className="flex flex-col md:flex-row items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-76" data-mp="1eq2ewieltguy">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-77" data-mp="qzycufh2dp62">
              <img src="https://cdn.magicpatterns.com/uploads/dS8mwrgUp8LQYy8oeRkX3X/bonus_1.png" alt="Banco de Producciones Escritas" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-78" data-mp="qy3ossahxgxr" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-79" data-mp="2epd21n1kjhcq">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-80" data-mp="2jhcvcwn4vc0c">
                🎁 BONUS 1 – Banco de Producciones Escritas
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-81" data-mp="2og7l6ijiq0ty">
                30 propuestas para pensar, argumentar y escribir.
              </p>
              <p className="text-lg mb-2" data-id="element-82" data-mp="1vs20fvsgsbu4">Incluye actividades sobre:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-83" data-mp="1vuehm6qeei64">
                <li className="flex items-center" data-id="element-84" data-mp="20qd8q2342ea8">
                  <span className="text-blue-500 mr-2" data-id="element-85" data-mp="20trb3abrynho">•</span> identidad
                </li>
                <li className="flex items-center" data-id="element-86" data-mp="25o52z2r8achl">
                  <span className="text-blue-500 mr-2" data-id="element-87" data-mp="3c5ihnntu592a">•</span> ciudadanía
                </li>
                <li className="flex items-center" data-id="element-88" data-mp="3h4llj4y2x98o">
                  <span className="text-blue-500 mr-2" data-id="element-89" data-mp="3h7hlszxega0a">•</span> democracia
                </li>
                <li className="flex items-center" data-id="element-90" data-mp="1h5hxinoh7sh8">
                  <span className="text-blue-500 mr-2" data-id="element-91" data-mp="1c395btjfgug6">•</span> ambiente
                </li>
                <li className="flex items-center" data-id="element-92" data-mp="1q4d96faahurx">
                  <span className="text-blue-500 mr-2" data-id="element-93" data-mp="1q1zazxkbc2g5">•</span> tecnología
                </li>
                <li className="flex items-center" data-id="element-94" data-mp="1m0dt1xsx8xz3">
                  <span className="text-blue-500 mr-2" data-id="element-95" data-mp="yc4f1i1y9eii">•</span> convivencia
                </li>
                <li className="flex items-center" data-id="element-96" data-mp="tem1tfgwgd4p">
                  <span className="text-blue-500 mr-2" data-id="element-97" data-mp="tbq4ntcvlshb">•</span> memoria
                </li>
                <li className="flex items-center" data-id="element-98" data-mp="176iqtan9u6wv">
                  <span className="text-blue-500 mr-2" data-id="element-99" data-mp="12e9403hgdmyt">•</span> cultura
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-100" data-mp="env9857hha0j">
                Ideal para trabajar producción escrita durante todo el año.
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-101" data-mp="i3adp5my5xi">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-102" data-mp="3mquugdmkcft7">
              <img src="https://cdn.magicpatterns.com/uploads/9jsSnCAnuKs5WQapCjUvLU/bonus_2.png" alt="Banco de Debates para Secundaria" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-103" data-mp="3moi3jaytuv40" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-104" data-mp="o8gvswtpt6j4">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-105" data-mp="9bq3t8mdex3j">
                🎁 BONUS 2 – Banco de Debates para Secundaria
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-106" data-mp="e985cdy26a1i">
                Temas actuales para dialogar, reflexionar y participar.
              </p>
              <p className="text-lg mb-2" data-id="element-107" data-mp="2z10kq4xjj7d6">Incluye debates sobre:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-108" data-mp="2z2boi4qzkf4a">
                <li className="flex items-center" data-id="element-109" data-mp="3f8es4udn6ot5">
                  <span className="text-blue-500 mr-2" data-id="element-110" data-mp="3fa9co7l04ewp">•</span> inteligencia
                  artificial
                </li>
                <li className="flex items-center" data-id="element-111" data-mp="35i3nt6q1qdlq">
                  <span className="text-blue-500 mr-2" data-id="element-112" data-mp="35iv6xi2giiv4">•</span> redes sociales
                </li>
                <li className="flex items-center" data-id="element-113" data-mp="30kts59c2d5pg">
                  <span className="text-blue-500 mr-2" data-id="element-114" data-mp="21d63ul3qc47">•</span> democracia
                </li>
                <li className="flex items-center" data-id="element-115" data-mp="3t87homdfmyzj">
                  <span className="text-blue-500 mr-2" data-id="element-116" data-mp="3t8h7a8ukf44p">•</span> ambiente
                </li>
                <li className="flex items-center" data-id="element-117" data-mp="3o79zi9sfa4y1">
                  <span className="text-blue-500 mr-2" data-id="element-118" data-mp="3ja0ct1wf47dw">•</span> educación
                </li>
                <li className="flex items-center" data-id="element-119" data-mp="2ctocova1cffo">
                  <span className="text-blue-500 mr-2" data-id="element-120" data-mp="2cv978kwcnydj">•</span> tecnología
                </li>
                <li className="flex items-center" data-id="element-121" data-mp="27ttmkty33tvo">
                  <span className="text-blue-500 mr-2" data-id="element-122" data-mp="nckbqy280c80">•</span> convivencia
                </li>
                <li className="flex items-center" data-id="element-123" data-mp="sbnak0rlxm7j">
                  <span className="text-blue-500 mr-2" data-id="element-124" data-mp="scf6xdt13nyv">•</span> cultura
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-125" data-mp="x95ne28qwlkt">
                Listo para usar en cualquier curso.
              </p>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="flex flex-col md:flex-row items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-126" data-mp="172mf90pbnqlu">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-127" data-mp="1g183nchh5zuj">
              <img src="https://cdn.magicpatterns.com/uploads/9z9LYLqUtWdKTBybRcSxUS/bonus_3.png" alt="50 Actividades de Ciudadanía" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-128" data-mp="1g211tp2dbh12" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-129" data-mp="3msh0h2ev88ps">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-130" data-mp="3eqzycktvhhm3">
                🎁 BONUS 3 – 50 Actividades de Ciudadanía
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-131" data-mp="3aqfyvaltu1ws">
                Recursos listos para trabajar:
              </p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-132" data-mp="3oqqsumifnwm6">
                <li className="flex items-center" data-id="element-133" data-mp="3jpjiqgstilcc">
                  <span className="text-blue-500 mr-2" data-id="element-134" data-mp="3js5t0o73fey9">•</span> participación
                  ciudadana
                </li>
                <li className="flex items-center" data-id="element-135" data-mp="3to8stneh31i1">
                  <span className="text-blue-500 mr-2" data-id="element-136" data-mp="3tnr0h1uxl7fe">•</span> democracia
                </li>
                <li className="flex items-center" data-id="element-137" data-mp="b8ya5143lu9r">
                  <span className="text-blue-500 mr-2" data-id="element-138" data-mp="6b6kkdqxek8q">•</span> convivencia
                </li>
                <li className="flex items-center" data-id="element-139" data-mp="l8grrawjd3yn">
                  <span className="text-blue-500 mr-2" data-id="element-140" data-mp="l98o4nxyj5pz">•</span> diversidad
                </li>
                <li className="flex items-center" data-id="element-141" data-mp="ganksfnes5xb">
                  <span className="text-blue-500 mr-2" data-id="element-142" data-mp="zv5z1yx14lfl">•</span> derechos humanos
                </li>
                <li className="flex items-center" data-id="element-143" data-mp="13wr633mvu5hv">
                  <span className="text-blue-500 mr-2" data-id="element-144" data-mp="13vg2b3tfsxqr">•</span> ambiente
                </li>
                <li className="flex items-center" data-id="element-145" data-mp="pw6o29oskdpf">
                  <span className="text-blue-500 mr-2" data-id="element-146" data-mp="uw2ro7tku34g">•</span> ciudadanía
                  digital
                </li>
                <li className="flex items-center" data-id="element-147" data-mp="g6n4f1t98fti">
                  <span className="text-blue-500 mr-2" data-id="element-148" data-mp="g5vhefdq3qeu">•</span> solidaridad
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-149" data-mp="kzq2nn8z8dg1">
                Ideal para tutorías, proyectos y jornadas escolares.
              </p>
            </div>
          </div>

          {/* Bonus 4 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-150" data-mp="3td6sn0jhi68f">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-151" data-mp="262oqeimz048">
              <img src="https://cdn.magicpatterns.com/uploads/tejSKTZ6CiUS9NCBRaTtRn/bonus_4.png" alt="Del Aula al Mundo" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-152" data-mp="hpx5lmrhpe7l" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-153" data-mp="8qju6ojt2fk8">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-154" data-mp="3okq1cg8rem8">
                🎁 BONUS 4 – Del Aula al Mundo
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-155" data-mp="3ux8dbxy1lbwf">
                Temas actuales para pensar el presente.
              </p>
              <p className="text-lg mb-2" data-id="element-156" data-mp="3m3mykelvnun0">Incluye:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-157" data-mp="3m452lxes7d5h">
                <li className="flex items-center" data-id="element-158" data-mp="3h528v9494tct">
                  <span className="mr-2" data-id="element-159" data-mp="3h6dab2a85p0r">🌎</span> Inteligencia Artificial
                </li>
                <li className="flex items-center" data-id="element-160" data-mp="3c4xmj2gnx4eo">
                  <span className="mr-2" data-id="element-161" data-mp="375uk7ps2hcae">🌎</span> Redes Sociales
                </li>
                <li className="flex items-center" data-id="element-162" data-mp="2x2fpxut8c02k">
                  <span className="mr-2" data-id="element-163" data-mp="2x1wackr1xnrp">🌎</span> Noticias Falsas
                </li>
                <li className="flex items-center" data-id="element-164" data-mp="320h88ditzvcz">
                  <span className="mr-2" data-id="element-165" data-mp="370lu6j2idial">🌎</span> Salud Mental
                </li>
                <li className="flex items-center" data-id="element-166" data-mp="36yish1rzu0q1">
                  <span className="mr-2" data-id="element-167" data-mp="3bzyccqifq16u">🌎</span> Cambio Climático
                </li>
                <li className="flex items-center" data-id="element-168" data-mp="2ecg5xmc8xb60">
                  <span className="mr-2" data-id="element-169" data-mp="2edr85hq1mav0">🌎</span> Participación Juvenil
                </li>
                <li className="flex items-center" data-id="element-170" data-mp="2jbapiqi1f3r6">
                  <span className="mr-2" data-id="element-171" data-mp="2o9kjixs0zyb7">🌎</span> Diversidad
                </li>
                <li className="flex items-center" data-id="element-172" data-mp="2t0u8rx9nwzmk">
                  <span className="mr-2" data-id="element-173" data-mp="2t2dpfoz8dcov">🌎</span> Profesiones del Futuro
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-174" data-mp="1vl6mak8rh60p">
                Un recurso moderno pensado para conectar la escuela con los
                desafíos actuales.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}